<template>
<div v-if="isShow" id="notes" class="notes" :style="{ 'background-image': 'url('+ bg +')' }">
  <div id="js-show-contents" class="ml32 mr32 contents">
    <router-link :to="{ name: 'Notes', params: {} }" class="back_btn">戻る</router-link>
    <h1 class="title ab">諦めてはダメだ！</h1>
    <p class="text rr">
      私がネットワークビジネスに携わり夢を実現しようと決めたとき、いろいろな意見をもらいました。心が揺れることもありました。それでも私には成し遂げたい夢がありました。<br>
      マジック・ジョンソンの名言はそのころから今にいたるまで何度も胸に刻み私の人生の指針となっています。<br>
      <br>
      この名言がナチュラリープラス ビジネスをすると決断したあなたにとっても夢を叶える一助になりますように。
    </p>
    <p class="name rr">Takashi Tajima</p>
  </div>
  <div id="js-note-audio" class="note_audio">
    <div id="js-audio-contents" class="note_contents">
      <AudioTitle
        :title="getTitle()"
      />
      <AudioPlayer
        ref="AudioPlayer"
        @endChapter="endChapter"
      />

    </div>
    <AudioChapter
      :isChapter="false"
      :chapterList="getChapter()"
      :nowSeqNo="nowSeqNo"
    />

  </div>
</div>
<div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>

<script>
import Config from '@/config/config';
import Check from '@/model/getToken';
import Height from '@/model/notes/height';
import NoteApi from '@/components/api/fanClub/notes';
import AudioPlayer from  '@/components/fanClub/notes/AudioPlayer';
import AudioTitle from  '@/components/fanClub/notes/AudioTitle';
import AudioChapter from  '@/components/fanClub/notes/AudioChapter';

export default {
  components: {
    AudioTitle,
    AudioPlayer,
    AudioChapter,
  },
  data() {
    return {
      // test_bg_num: 0,
      // test_bg: [
      //   require('@/assets/images/fanClub/notes/bg_do_not_give_up.png'),
      //   require('@/assets/images/fanClub/notes/test/test_2-1.png'),
      //   require('@/assets/images/fanClub/notes/test/test_2-2.png'),
      // ],

      isShow: true,
      bg: require('@/assets/images/fanclub/notes/bg_do_not_give_up.png'),
      // bg: require('@/assets/images/fanClub/notes/bg.jpg'),
      nowSeqNo: 0,
      everyDayNote: {
        enabled: false,
        existsNew: false,
        note: {
          title: '',
          startSeqNo: 1,
          existsNew: false,
          chapterList: [],
        }
      },
    }
  },
  methods: {
    getTitle() {
      return this.everyDayNote.note.title;
    },
    // testChangeBG(index) {
    //   this.test_bg_num = index;
    // },
    setData(data) {
      this.everyDayNote.enabled = data.everyDayNote.enabled;
      this.everyDayNote.existsNew = data.everyDayNote.existsNew;
      this.everyDayNote.note.title = data.everyDayNote.note.title;
      this.everyDayNote.note.startSeqNo = data.everyDayNote.note.startSeqNo;
      this.everyDayNote.note.existsNew = data.everyDayNote.note.existsNew;
      this.everyDayNote.note.chapterList.push(...data.everyDayNote.note.chapterList);

      this.nowSeqNo = this.everyDayNote.note.startSeqNo;
    },
    getChapter() {
      return this.everyDayNote.note.chapterList;
    },
    endChapter() {
      console.log('終わり検知');
      let index = this.everyDayNote.note.chapterList.findIndex(val => val.seqNo == this.nowSeqNo);
      this.nowSeqNo = this.everyDayNote.note.chapterList[index].nextSeqNo;
      this.setAudio();
    },
    setAudio() {
      let nowChapter = this.everyDayNote.note.chapterList;
      let index = nowChapter.findIndex(val => val.seqNo == this.nowSeqNo);

      this.$refs.AudioPlayer.setAudio(nowChapter[index].audioPath);
    },
    async apiGetNote() {
      await NoteApi.getNote().then((val) => {
        console.log('音声データ');
        console.log(val);
        // this.$refs.AudioPlayer.setAudio(this.note.everyDayNote.note.chapterList[0].audioPath);
        this.setData(val);
        this.setAudio();
      });
    },
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      // this.initialized(); // 初期化
      await this.apiGetNote(); // データ取得
      Height.initializedScroll();
      // Height.setScrollPosition();
      // this.toggleAudio();
    } else {
      this.isShow = false;
    }
  },
}
</script>

<style lang="css" scoped>
.back_btn {
  border: 1px solid  #fff;
  border-radius: 10px;
  color: #fff;
  display: block;
  margin-left: auto;
  text-align: center;
  width: 60px;
}

.test_btn {
  position: relative;
  z-index: 1;
}
.notes {
  /* height: 100%;
  overflow: hidden; */
  position: relative;
}
.notes::before {
  background-color: rgba(0, 0, 0, .5);
  content: '';
  top: 0;
  left: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
}
.notes .notes_wrap {
  transition: transform .3s;
}

.notes {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top 0 center;
}

.note_audio {
  background: rgba(0, 89, 163, 0.3);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(27.18px);
  left: 0;
  margin-top: 16px;
  padding: 0 24px 56px;
  position: fixed;
  transition: transform .3s;
  transform: translateY(0);
  width: 100%;
  z-index: 10;
  /* top: 477px; */
}
.note_contents {
  padding: 16px 0 25px;
  /* padding-bottom: 25px; */
}


.contents {
  padding-top: 16px;
  position: relative;
  z-index: 1;
  /* max-height: 420px;
  overflow-y: scroll; */
}
.title, .text, .name {
  color: #fff;
}
.title {
  font-size: 20px;
}
.text {
  font-size: 17px;
  /* line-height: 1.7; */
  margin-top: 16px;
}
.name {
  font-size: 17px;
  margin-top: 40px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/fanClub/notes/NotesDoNotGiveUp.vue